import { checkServerHealth, generateAccessPass } from '../services/serverService';

/**
 * Test function to verify server connectivity
 * Call this from browser console: testServerConnection()
 */
export async function testServerConnection() {
  console.log('Testing server connection...');
  
  try {
    const health = await checkServerHealth();
    console.log('Server health check result:', health);
    
    if (health.status === 'ok') {
      console.log('✅ Server is running correctly!');
    } else {
      console.log('⚠️ Server is running but reported an issue:', health.message);
    }
    
    return health;
  } catch (error) {
    console.error('❌ Server connection test failed:', error);
    throw error;
  }
}

/**
 * Test function to verify access pass generation
 * Call this from browser console: testAccessGeneration()
 */
export async function testAccessGeneration() {
  console.log('Testing access pass generation...');
  
  const testData = {
    customerName: 'Test User',
    contactNumber: '1234567890',
    validDate: new Date().toISOString().split('T')[0], // Today's date in YYYY-MM-DD
    pickupTime: '10:30',
    returnTime: '17:30',
    type: 'Collection',
    qrid: 'TEST-QR-123' // This QRID should now be used as the Access Code
  };
  
  console.log('Sending data with QRID:', testData.qrid);
  console.log('This QRID value should be used both as QRID and Access Code in the sheet');
  
  try {
    const result = await generateAccessPass(testData);
    console.log('Access generation test result:', result);
    
    if (result.success) {
      console.log('✅ Access pass generated successfully!');
      console.log('Unique ID:', result.uniqueId);
      console.log('The QRID value should now be set as Access Code in Google Sheets');
    } else {
      console.log('⚠️ Access pass generation failed:', result.error);
    }
    
    return result;
  } catch (error) {
    console.error('❌ Access generation test failed:', error);
    throw error;
  }
}

// Export these functions to window to make them callable from the console
declare global {
  interface Window {
    testServerConnection: () => Promise<any>;
    testAccessGeneration: () => Promise<any>;
  }
}

if (typeof window !== 'undefined') {
  window.testServerConnection = testServerConnection;
  window.testAccessGeneration = testAccessGeneration;
} 